import {
  fetchAllCategoriesRequest,
  fetchSingleCategoryRequest,
  upsertCategoryRequest,
} from 'actions/categories';
import { GlobalState } from 'reducers';
import { createSelector } from 'reselect';
import type { Category, Model, NormalizedResource, Selector, UUID } from 'types';

export const getFetchAllCategoriesLoading: Selector<boolean> = (state) =>
  state.categories.loading.includes(fetchAllCategoriesRequest.toString());

export const getFetchSingleCategoryLoading: Selector<boolean> = (state) =>
  state.categories.loading.includes(fetchSingleCategoryRequest.toString());

export const getUpsertCategoryLoading: Selector<boolean> = (state) =>
  state.categories.loading.includes(upsertCategoryRequest.toString());

export const getCategory =
  (id: UUID): Selector<Category> =>
  (state): Category =>
    state.categories.categories[id];

export const getAllCategories: Selector<NormalizedResource<Category>> = (state) =>
  state.categories.categories;

export const getCategoriesList: Selector<Category[]> = createSelector(
  [(state: GlobalState): GlobalState['categories']['categories'] => state.categories.categories],
  (categories) => Object.values(categories)
);

export const getModelsFromCategories: Selector<Model[]> = createSelector(
  [(state: GlobalState): GlobalState['categories']['categories'] => state.categories.categories],
  (categories) => {
    const models: Model[] = [];

    Object.values(categories).forEach((c) => {
      if (c.model && !models.find((m) => m.uuid === c.model_uuid)) {
        models.push(c.model);
      }
    });
    return models;
  }
);

export const getActiveCategory: Selector<UUID> = (state) => state.categories.activeCategory;

export const getCategoriesTotalCount: Selector<number> = (state) => state.categories.count;

export const getModelsIdsFromCategories: Selector<string[]> = createSelector(
  [(state: GlobalState): GlobalState['categories']['categories'] => state.categories.categories],
  (categories) => {
    const models: string[] = [];

    Object.values(categories).forEach((c) => {
      if (c.model && !c.model.deleted_by_uuid) {
        models.push(c.model_uuid);
      }
    });

    return [...new Set(models)];
  }
);

export const getRuleGroupIdsFromCategories: Selector<string[]> = createSelector(
  [(state: GlobalState): GlobalState['categories']['categories'] => state.categories.categories],
  (categories) => {
    const rules: string[] = [];

    Object.values(categories).forEach((c) => {
      if (c.rule?.rule_group_uuid) {
        rules.push(c.rule?.rule_group_uuid);
      }
    });
    return [...new Set(rules)];
  }
);
